import styles from "./part2.module.scss";
export default function HomePart2() {
  const listArr = [
    {
      pic: "/img/img_numbers.png",
      title: "Multiple Numbers on One Phone",
      desc: "You can pick a 2nd phone number to separate life and business. Multiple numbers can be used on one phone with Dingtone app applied.",
    },
    {
      pic: "/img/img_earth.png",
      title: "Calling Codes for Multiple Countries",
      desc: "Dingtone provides real phone numbers for US, UK, Canada, Australia, etc. and ones with local area codes to unlimitedly call and text with Internet.",
    },
    {
      pic: "/img/img_features.png",
      title: "Business Phone Features",
      desc: "Dingtone app also provides business phone features to boost business through calling such as voicemail, call forwarding, block call, etc.",
    },
  ];
  return (
    <div className={styles.part2 + " main"}>
      <div className={styles.top}>
        <h2>We Give You a Real Phone Number</h2>
        <p>
          Receive calls and texts, even voicemails. Set up call block, call
          forwarding...
        </p>
      </div>

      <div className={styles.inner + " flex-r"}>
        {listArr.map((item, index) => (
          <div key={index} className={styles.item}>
            <img src={item.pic} alt={item.title} />
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
